import styled from "@emotion/styled";
import { motion } from "framer-motion";

export const SectionRandomFact = styled(motion.div)`
    background-color: rgb(240, 240, 240);
`;

export const ContainerRandomFact = styled.div`
    margin: 0 auto;
    padding-top: 50px;
    padding-bottom: 50px;
    width: 1200px;
    display: flex;
`;

export const Img = styled(motion.img)`

`;

export const Describe = styled(motion.div)`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Title = styled.h2`
    margin: 0;
    margin-bottom: 15px;
    font-size: 40px;
    font-family: "Bitter",serif;

`;

export const FactsUl = styled.ul`
  padding: 0;
`;

export const FactLi = styled.li`
    margin: 0;
    margin-bottom: 15px;
    font-size: 25px;
    font-family: "Bitter",serif;
`;

export const Button = styled.button`
    margin: 0;
`;
